import { Appointment } from "../models/admissions.model";
import { ProcedureRoomListing } from "../models/procedure-room.model";

/** Matches POST /procedure/list-procedure excluded schedule statuses (as-phi-v2). */
const PROCEDURE_LIST_EXCLUDED_STATUS_COMPACT = new Set([
  "waitlist",
  "cancelled",
  "rescheduled",
  "noshow",
]);

function compactProcedureListStatus(raw: string | null | undefined): string {
  return String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
}

export function isProcedureListExcludedStatus(
  raw: string | null | undefined
): boolean {
  const compact = compactProcedureListStatus(raw);
  return compact !== "" && PROCEDURE_LIST_EXCLUDED_STATUS_COMPACT.has(compact);
}

/** Drop waitlist / cancelled / rescheduled / no-show from procedure list + pipeline. */
export function isExcludedFromProcedureListDisplay(
  row: Appointment | ProcedureRoomListing | null | undefined
): boolean {
  if (!row) {
    return false;
  }
  if ("encounterSchedule" in row || "encountersPatient" in row) {
    const appt = row as Appointment;
    const schedule = appt.encounterSchedule;
    const proc = appt.encounterProcedure;
    const ext = appt as Appointment & {
      clinicalStatus?: string | null;
      scheduleStatus?: string | null;
    };
    const candidates = [
      appt.encounterStatus,
      ext.clinicalStatus,
      ext.scheduleStatus,
      schedule?.scheduleStatus,
      proc?.patientStatus,
    ];
    return candidates.some((s) => isProcedureListExcludedStatus(String(s ?? "")));
  }
  const listing = row as ProcedureRoomListing;
  return isProcedureListExcludedStatus(listing.patientStatus);
}

export function filterProcedureListDisplayRows<T extends Appointment>(
  rows: T[] | null | undefined
): T[] {
  return (rows ?? []).filter((row) => !isExcludedFromProcedureListDisplay(row));
}

export function filterProcedureRoomListingDisplayRows(
  rows: ProcedureRoomListing[] | null | undefined
): ProcedureRoomListing[] {
  return (rows ?? []).filter((row) => !isExcludedFromProcedureListDisplay(row));
}
